export default __webpack_public_path__ + "static/hfn-meditate-68e03cd7071985761cf8b322e1692d6c.png";